module.exports = new __parcel__URL__("issue-breakdown-line.tpl.93dbb47e.svg").toString();